import { take, call, put } from 'redux-saga/effects';
import {
  loadFeaturedClusters,
  updateFeaturedClusters,
  removeUnsavedFeaturedClusters,
} from './featured-cluster.actions';
import { callApi } from '../../api';
import {
  fetchFeaturedClustersCallOptions,
  ApiFeaturedCluster,
  saveFeaturedClustersCallOptions,
  removeFeaturedClusterCallOptions,
} from '../../../services/featured-cluster.services';
import { schema, normalize } from 'normalizr';
import { FeaturedCluster } from './featured-cluster.reducer';

export const featuredClusterSchema = new schema.Entity(
  'featuredClusters',
  undefined,
  {
    idAttribute: 'id',
    processStrategy: (entity: ApiFeaturedCluster): FeaturedCluster => ({
      appId: entity.app_id,
      gender: entity.gender,
      clusterId: entity.cluster_id,
      position: entity.position,
      activeFrom: entity.active_from,
      activeTo: entity.active_to,
      id: entity.id,
      cluster: entity.cluster,
      dirty: false,
    }),
  }
);

export function* fetchFeaturedClusters() {
  const { ok, data } = yield call(callApi, fetchFeaturedClustersCallOptions());

  if (ok) {
    const normalized = normalize(data.data, [featuredClusterSchema]);

    yield put(
      updateFeaturedClusters({
        ...normalized.entities.featuredClusters,
      })
    );
  }
}

export function* watchForLoadFeaturedClusters() {
  while (true) {
    yield take(loadFeaturedClusters);

    yield call(fetchFeaturedClusters);
  }
}

export function* saveFeaturedClusters(featuredClusters: FeaturedCluster[]) {
  const callOption = saveFeaturedClustersCallOptions(
    featuredClusters as FeaturedCluster[]
  );
  const { ok, data } = yield call(callApi, callOption);

  if (ok) {
    const normalized = normalize(data.data, [featuredClusterSchema]);

    yield put(removeUnsavedFeaturedClusters());

    yield put(
      updateFeaturedClusters({
        ...normalized.entities.featuredClusters,
      })
    );
  }
}

export function* removeFeaturedCluster(featuredCluster: FeaturedCluster) {
  const callOption = removeFeaturedClusterCallOptions(featuredCluster.id);
  yield call(callApi, callOption);
}



// WEBPACK FOOTER //
// ./src/store/Entities/FeaturedCluster/featured-cluster.saga.ts